/**
 * Router component that define a routing system
 */
var RouterComponent = /** @class */ (function () {
    function RouterComponent() {
    }
    Object.defineProperty(RouterComponent.prototype, "layout", {
        // Getters
        /**
         * Get the layout value
         */
        get: function () {
            return this._layout;
        },
        // Setters
        /**
         * Set the layout value
         */
        set: function (layout) {
            this._layout = layout;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RouterComponent.prototype, "routers", {
        /**
         * Get the list of routers
         */
        get: function () {
            return this._routers;
        },
        /**
         * Set the list of routers
         */
        set: function (routers) {
            this._routers = routers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RouterComponent.prototype, "pages", {
        /**
         * Get the list of pages
         */
        get: function () {
            return this._pages;
        },
        /**
         * Set the list of pages
         */
        set: function (pages) {
            this._pages = pages;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RouterComponent.prototype, "loaderComponent", {
        /**
         * Get the loader component
         */
        get: function () {
            return this._loaderComponent;
        },
        /**
         * Set the loader component
         */
        set: function (loaderComponent) {
            this._loaderComponent = loaderComponent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RouterComponent.prototype, "notFoundComponent", {
        /**
         * Get the not found component
         */
        get: function () {
            return this._notFoundComponent;
        },
        /**
         * Set the not found component
         */
        set: function (notFoundComponent) {
            this._notFoundComponent = notFoundComponent;
        },
        enumerable: false,
        configurable: true
    });
    return RouterComponent;
}());
export { RouterComponent };
